import './landing.css';

export default function LandingPage() {
  return (
    <main className="landing-page">
      <section className="landing-hero">
        <img
          src="/assets/hero-students.jpg"
          alt="Élèves du Groupe Scolaire Le Défi"
          className="landing-hero-image"
        />
        <div className="landing-hero-overlay" aria-hidden="true" />

        <header className="landing-header">
          <a href="/" className="landing-logo-link" aria-label="Accueil Le Défi">
            <img src="/assets/logo.png" className="landing-logo" alt="Le Défi" />
          </a>

          <a href="/login" className="landing-button landing-button-small">
            Connexion
          </a>
        </header>

        <div className="landing-hero-content">
          <h1>Groupe Scolaire Le Défi</h1>
          <p>
            Le Groupe Scolaire Le Défi est un établissement scolaire privé à Bizerte,
            offrant un enseignement de qualité aux cycles préparatoire, primaire et collège.
          </p>
          <a href="/login" className="landing-button landing-button-main">
            Connexion
          </a>
        </div>
      </section>

      <section className="landing-features" aria-label="Services principaux">
        <article className="landing-feature">
          <span className="landing-feature-icon" aria-hidden="true">👨‍👩‍👧</span>
          <div><h3>Espace parents</h3><p>Suivre les informations importantes.</p></div>
        </article>
        <article className="landing-feature">
          <span className="landing-feature-icon" aria-hidden="true">📚</span>
          <div><h3>Suivi scolaire</h3><p>Rester proche du parcours de l’élève.</p></div>
        </article>
        <article className="landing-feature">
          <span className="landing-feature-icon" aria-hidden="true">💬</span>
          <div><h3>Communication</h3><p>Un lien clair avec l’école.</p></div>
        </article>
      </section>

      <section className="landing-intro" id="decouvrir">
        <article className="landing-panel landing-intro-text">
          <span className="landing-tag">Notre vision</span>
          <h2>Une école pensée pour révéler chaque potentiel</h2>
          <p>
            Au Défi, chaque élève avance dans un environnement rassurant, structuré et stimulant.
            Notre objectif est d’accompagner les enfants dans leurs apprentissages, leur confiance
            en eux et leur épanouissement personnel.
          </p>
        </article>

        <article className="landing-panel landing-intro-box">
          <h3>Ce que nous construisons chaque jour</h3>
          <ul>
            <li>Un climat scolaire positif et motivant.</li>
            <li>Un suivi attentif du progrès de chaque enfant.</li>
            <li>Une relation solide entre l’école et la famille.</li>
            <li>Des activités qui encouragent la curiosité et l’autonomie.</li>
          </ul>
        </article>
      </section>

      <section className="landing-cycles" id="cycles">
        <span className="landing-tag">Nos parcours</span>
        <h2>Nos cycles</h2>
        <div className="landing-title-line" aria-hidden="true" />

        <div className="landing-cycle-grid">
          <article className="landing-cycle-card">
            <img src="/assets/preparatoire.jpg" alt="Cycle préparatoire" />
            <div><span className="landing-round-icon" aria-hidden="true">▣</span><h3>Préparatoire</h3><p>Explorer, jouer, apprendre</p></div>
          </article>
          <article className="landing-cycle-card">
            <img src="/assets/primaire.jpg" alt="Cycle primaire" />
            <div><span className="landing-round-icon" aria-hidden="true">📖</span><h3>Primaire</h3><p>Construire les bases</p></div>
          </article>
          <article className="landing-cycle-card">
            <img src="/assets/college.jpg" alt="Cycle collège" />
            <div><span className="landing-round-icon" aria-hidden="true">🎓</span><h3>Collège</h3><p>S’informer, raisonner, réussir</p></div>
          </article>
        </div>
      </section>

      <section className="landing-why">
        <span className="landing-tag">Pourquoi nous choisir ?</span>
        <h2>Un accompagnement complet</h2>
        <div className="landing-why-grid">
          <article className="landing-panel"><h3>Encadrement sérieux</h3><p>Une équipe attentive, présente et engagée dans la réussite des élèves.</p></article>
          <article className="landing-panel"><h3>Environnement motivant</h3><p>Des espaces et des activités qui donnent envie d’apprendre chaque jour.</p></article>
          <article className="landing-panel"><h3>Communication claire</h3><p>Les parents sont informés et accompagnés tout au long de l’année.</p></article>
          <article className="landing-panel"><h3>Progression suivie</h3><p>Chaque enfant est encouragé selon son rythme et ses besoins.</p></article>
        </div>
      </section>

      <section className="landing-steps">
        <span className="landing-tag">Connexion</span>
        <h2>Accéder à votre espace</h2>
        <div className="landing-step-grid">
          <article className="landing-panel"><span>01</span><h3>Cliquez sur Connexion</h3><p>Utilisez le bouton en haut de la page ou le bouton principal.</p></article>
          <article className="landing-panel"><span>02</span><h3>Choisissez votre profil</h3><p>Parent ou administration selon votre espace.</p></article>
          <article className="landing-panel"><span>03</span><h3>Accédez au suivi</h3><p>Consultez les informations et les services disponibles.</p></article>
        </div>
      </section>

      <section className="landing-cta" id="connexion">
        <div className="landing-cta-icon" aria-hidden="true">🔐</div>
        <h2>Accédez à votre espace<br /><span>Le Défi</span> en toute simplicité</h2>
        <a href="/login" className="landing-button">Connexion →</a>
      </section>

      <footer className="landing-footer" id="contact">
        <div>📍 Bizerte, Tunisie</div>
        <div>📞 +216 58 441 534</div>
        <div className="landing-signature">Le Défi,<br />Votre Réussite, Notre Défi</div>
      </footer>
    </main>
  );
}
